import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NAV } from "@/data/site";
import { EASE } from "@/lib/motion";

export const Nav = ({ onBrief }) => {
  const [compact, setCompact] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setCompact(window.scrollY > 90);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        data-testid="site-nav"
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 2.3, duration: 0.9, ease: EASE }}
        className="fixed left-0 right-0 top-0 z-50 border-b transition-colors duration-500"
        style={{
          borderColor: compact ? "#1f1f1f" : "transparent",
          backgroundColor: compact ? "rgba(10,10,10,0.82)" : "transparent",
          backdropFilter: compact ? "blur(14px)" : "none",
        }}
      >
        <div
          className="mx-auto flex max-w-[1700px] items-center justify-between px-5 transition-all duration-500 md:px-10"
          style={{ height: compact ? 60 : 88 }}
        >
          <a
            href="#top"
            data-cursor="view"
            data-testid="nav-logo"
            className="flex items-center gap-3"
          >
            <img
              src="/brand/hsk-logo.png"
              alt="HSK"
              className="w-auto transition-all duration-500"
              style={{ height: compact ? 18 : 26 }}
            />
          </a>

          <nav className="hidden items-center gap-9 md:flex">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                data-cursor="view"
                data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="group relative label text-[#a3a3a3] transition-colors duration-300 hover:text-[#e5e5e5]"
              >
                {n.label}
                <span className="absolute -bottom-1.5 left-0 h-[1px] w-0 bg-[#d4ff00] transition-all duration-400 group-hover:w-full" />
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <span className="hidden label text-[#7a7a7a] lg:block">
              AVAILABLE FOR WORK
              <span className="ml-2 inline-block h-[6px] w-[6px] animate-pulse rounded-full bg-[#d4ff00] align-middle" />
            </span>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              data-testid="nav-menu-toggle"
              className="flex h-8 w-8 flex-col items-end justify-center gap-[5px] md:hidden"
              aria-label="Menu"
            >
              <span
                className="h-[1px] bg-[#e5e5e5] transition-all duration-300"
                style={{ width: open ? 20 : 20, transform: open ? "rotate(45deg) translateY(3px)" : "none" }}
              />
              <span
                className="h-[1px] bg-[#e5e5e5] transition-all duration-300"
                style={{ width: open ? 20 : 13, transform: open ? "rotate(-45deg) translateY(-3px)" : "none" }}
              />
            </button>
          </div>
        </div>
      </motion.header>

      <motion.div
        data-testid="mobile-menu"
        initial={false}
        animate={{ clipPath: open ? "inset(0 0 0% 0)" : "inset(0 0 100% 0)" }}
        transition={{ duration: 0.6, ease: EASE }}
        className="fixed inset-0 z-[49] flex flex-col justify-center bg-[#0a0a0a] px-6 md:hidden"
        style={{ pointerEvents: open ? "auto" : "none" }}
      >
        {NAV.map((n, i) => (
          <a
            key={n.label}
            href={n.href}
            onClick={() => setOpen(false)}
            data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
            className="border-b border-[#1f1f1f] py-5 font-display text-3xl font-extrabold tracking-tight text-[#e5e5e5]"
          >
            <span className="label mr-4 text-[#d4ff00]">0{i + 1}</span>
            {n.label}
          </a>
        ))}
        <button
          type="button"
          onClick={() => {
            setOpen(false);
            onBrief();
          }}
          data-testid="mobile-start-project"
          className="mt-10 bg-[#d4ff00] py-4 label text-[#0a0a0a]"
        >
          START A PROJECT →
        </button>
      </motion.div>
    </>
  );
};
